export const permissions = Object.freeze({
  none: 1,
  viewEmployee: 2,
  modifyEmployee: 3,
  viewEmployeeRestricted: 4,
  modifyEmployeeRestricted: 5,
  createEmployee: 6,
  viewWages: 7,
  modifyWages: 8,
  modifyPunches: 9,
  modifyUnmatchedPunches: 10,
  hubAdmin: 11,
  onboardingAdmin: 12,
  benefitsAdmin: 13,
  viewSchedule: 14,
  modifySchedule: 15,
  modifyPassword: 16,
  viewEmployeeContact: 17,
  modifyEmployeeContact: 18,
  viewRoles: 19,
  modifyRoles: 20,
  viewSettings: 21,
  modifyDeductions: 22,
  modifyNotifications: 23,
  timeOffAdmin: 24,
  geoFenceSubscriber: 25,
  genericEmployeeSelf: 26,
  viewEmployeeAgreement: 27,
  modifyEmployeeAgreement: 28,
  viewOrgChart: 29,
  viewBilling: 30,
  modifyBilling: 31,
  genericManagerDirectReports: 32,
  manageInvites: 33,
  applicantTrackingAdmin: 34,
  recruiter: 35,
  hiringManager: 36,
  viewEmployeeStatus: 37,
  modifyEmployeeStatus: 38,
  canAddAndEditPartnerLoginsPermissions: 39,
  canAccessTwpPortal: 40,
  basePartnerAccess: 41,
  partnerManager: 42,
  canManageCreditCard: 43,
  canImpersonate: 44,
  canCreateCompanies: 45,
  canConfigureCompanies: 46,
  canOrderClocksAndEquipment: 47,
  canAddPartners: 48,
  canEnableAdvancedScheduling: 49,
  canMigrateTimeWorksClient: 50,
  canSeeMigrationCandidateList: 51,
  baseSuperAdminAccess: 52,
  canAccessBillingFunctions: 53,
  canProcessCreditRequests: 54,
  canModifyDiscounts: 55,
  canExtendDemoAccounts: 56,
  canAccessAdvancedSupportFunctions: 57,
  canManageSuperAdminLogins: 58,
});
